import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";
import { DataHora } from "./Grid";
import DescricaoFinanceiro from "./DescricaoFinanceiro";

const FormContainer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 100px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const InputId = styled.input`
  width: 30px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const Label = styled.label``;

const Button = styled.button`
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #2c73d2;
  color: white;
  height: 42px;
`;

const Select = styled.select`
  width: 120px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
  background-color: #fff;
`;


const Title = styled.h2``;

const FormFinancas = ({ getUsers, onEdit, setOnEdit }) => {
  const refCarga = useRef();
  const refEfetivar = useRef();

  const [usuarios, setUsuarios] = useState([]);
  const [movimento, setMovimento] = useState([]);
  const [descricao, setDescricao] = useState([]);
  const [saldo, setSaldo] = useState(null);

  const [financeiro, setFinanceiro] = useState([]);

  const [usrMov, setUsrMov] = useState("");
  const [vlMov, setVlMov] = useState("");

  const [descricaoFiltrada, setDescricaoFiltrada] = useState([]);
  const [movimentoSelecionado, setMovimentoSelecionado] = useState(null);

  function handleMovimentoChange(event) {
    const idMovimento = Number(event.target.value);
    setMovimentoSelecionado(idMovimento);
  
    if (idMovimento === 1) {
      // Entrada - só descrição com id=1
      const desc = descricao.filter(d => d.id === 1);
      setDescricaoFiltrada(desc);
    } else if (idMovimento === 2) {
      // Saída - descrição com id=2 e id=3
      const desc = descricao.filter(d => d.id === 2 || d.id === 3 || d.id === 4);
      setDescricaoFiltrada(desc);
    } else {
      setDescricaoFiltrada([]);
    }
  }
  

  function getMovimento(){
    return  [
      {
        id: 2,
        descricao: "Saída"
      },
      {
        id: 1,
        descricao: "Entrada"
      }
    ]
      
  }

  function getDescricao(){

    return  [
      {
        id: 1,
        descricao: "Recebimento cartola",
        descricaoCliente: "Pagamento cartola",
      },
      {
        id: 2,
        descricao: "Pagamento premiação",
        descricaoCliente: "Recebimento premiação"
      },
      {
        id: 3,
        descricao: "Rodada free",
        descricaoCliente: "Rodada free",
      },
      {
        id: 4,
        descricao: "Adição de créditos",
        descricaoCliente: "Adição de créditos",
      }
  ]

  }

 /* useEffect(() => {
    if (onEdit) {
      const user = ref.current;

      user.id.value = onEdit.id;
      user.nome.value = onEdit.nome;
      user.login.value= onEdit.login;
      user.senha.value= onEdit.senha;
      user.valor.value= onEdit.valor;
      user.telefone.value= onEdit.telefone;
     
    }
  }, [onEdit]);*/

  useEffect(() => {
    const loadStatusOptions = async () => {
      try {
        const response = await api.get("/liga/listarUsuarios"); // Exemplo de endpoint
        setUsuarios(response.data);
       
      } catch (error) {
        console.error("Erro ao buscar status:", error);
      }
    };

    var movi = getMovimento();
    var desc = getDescricao();

    setMovimento(movi)
    setDescricao(desc);
  
    loadStatusOptions();
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
  
    const idUsuarioSelecionado = event.target.usuarios.value; // <- pega o ID selecionado
  
    const usuario = usuarios.find(u => u.id.toString() === idUsuarioSelecionado); // acha o objeto
  
    if (usuario) {
      console.log("Usuário selecionado:", usuario.nome);
      setUsrMov(usuario.nome)

      getFinanceiro(usuario.id);
   
    } else {
      console.log("Nenhum usuário selecionado.");
    }
  
    // aqui você pode continuar seu envio normalmente
  }

  async function handleEfetivar(event) {
    event.preventDefault();
  
    const formData = new FormData(event.target);
  
    const dados = {
      id: 0,
      idUsuario: saldo.id, // pega o valor do input
      valor: Number(formData.get('valor').replace(",", ".")),     // pega o valor digitado
      movimento: Number(formData.get('movimentoId')), // pega o id selecionado
      descricaoMovimento: formData.get('descricaoId')  // pega o id selecionado
    };
  
     await api.post("/liga/inserirFinanceiro", dados)
        .then(({ data }) => toast.success(data))
        .catch(({ data }) => toast.error(data));
  }

  async function getFinanceiro(idUsuario) {
    try {
      const res = await api.get("liga/ListaFinanceiro/"+idUsuario);
      setFinanceiro(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  function handleUsuarioChange(event) {
    const idSelecionado = event.target.value;
    const usuario = usuarios.find(u => u.id.toString() === idSelecionado);
    setSaldo(usuario || null);
  }

  return (
    <>
      <FormContainer ref={refCarga} onSubmit={handleSubmit}>

        <InputArea>
          <Label>Usuário</Label>
          <Select name="usuarios" onChange={handleUsuarioChange}>
            <option value="">Selecione</option>
            {usuarios.map((usuario) => (
              <option key={usuario.id} value={usuario.id}>
                {usuario.nome}
              </option>
            ))}
          </Select>
        </InputArea>
      
        <InputArea>
          <Label>Créditos atuais</Label>
          <InputId name="credito" disabled value={saldo?.valor !== undefined ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(saldo.valor) : ""} />
        </InputArea>
        
        <Button type="submit">Carregar extrato</Button>
      </FormContainer>

      <FormContainer ref={refEfetivar} onSubmit={handleEfetivar}>

        <InputArea>
          <Label>Usuário</Label>
          <Input name="usuario" disabled value={usrMov} />
        </InputArea>

        <InputArea>
          <Label>Valor</Label>
          <Input name="valor" />
        </InputArea>

        <InputArea>
          <Label>Movimento</Label>
          <Select name="movimentoId" onChange={handleMovimentoChange}>
            <option value="">Selecione</option>
            {movimento.map((m) => (
              <option key={m.id} value={m.id}>
                {m.descricao}
              </option>
            ))}
          </Select>
        </InputArea>


        <InputArea>
          <Label>Descrição</Label>
          <Select name="descricaoId">
            <option value="">Selecione</option>
            {descricaoFiltrada.map((d) => (
              <option key={d.id} value={d.descricao}>
                {d.descricaoCliente}
              </option>
            ))}
          </Select>
        </InputArea>


        <Button type="submit">Carregar</Button>
        </FormContainer>

        <DescricaoFinanceiro financeiro={financeiro} adm={true}/>
              

      </>
  );
};

export default FormFinancas;
